export const CREATE_DUPLICATE_MULTISIG = 'MultiSign wallet already exists.';
